import React from 'react'

const UserProductDetailPage = () => {
   return <div>User Product Detail Page</div>
}
export default UserProductDetailPage
